import ReactGA from "react-ga4";
import { getCurrentLocalFacilityId } from "modules/facility/facilityHooks";

// GA and Pendo are independent sinks: an ad blocker that drops the Pendo agent
// must not also drop the GA event.
function trackGaEvent(eventName: string) {
  ReactGA.event({
    category: "ClubhouseEvents",
    action: eventName,
    label: eventName,
  });
}

export function pendoTrackBasicEvent(eventName: string, simulatorId?: string) {
  window.pendo?.track(eventName, {
    simulatorId: simulatorId ? simulatorId : "",
    facilityId: getCurrentLocalFacilityId(),
  });
  trackGaEvent(eventName);
}

export function pendoTrackEventWithProperties(
  eventName: string,
  props: object,
) {
  window.pendo?.track(eventName, {
    ...props,
    facilityId: getCurrentLocalFacilityId(),
  });
  trackGaEvent(eventName);
}

export enum ClubhouseEvents {
  CONTROL_UPDATE_TERRAIN_EFFECTS = "Update Control Terrain Effects",
  CONTROL_UPDATE_PLAYER_PROFILE_TEE_TYPE = "Update Control Player Profile Tee Type",
  CONTROL_UPDATE_USE_FACILITY_DEFAULTS = "Update Control Use Facility Defaults",
  CONTROL_UPDATE_SAVE_ROUND_SETTINGS = "Update Control Save Round Settings",
  LOCKER_ROOM_SORT = "Sort Locker Room",
  LOCKER_ROOM_DATE_RANGE = "Date Range Locker Room",
  SHUTDOWN_SIMULATOR = "Shutdown Simulator",
  RESTART_SIMULATOR = "Restart Simulator",
  RESYNC_SIMULATOR = "Resync Simulator",
  CREATE_RESERVATION = "Create Simulator Reservation",
  DELETE_RESERVATION = "Delete Simulator Reservation",
  EDIT_RESERVATION = "Edit Simulator Reservation",
  START_ROUND = "Start Ad Hoc Round",
  END_ROUND = "End Round",
  SEND_TO_SIM = "Send Simulator Reservation",
  CLEAR_TIMER = "Clear Timer",
  PAUSE_TIMER = "Pause Timer",
  UNPAUSE_TIMER = "Unpause Timer",
  START_TIMER = "Start Timer",
  ADD_TIME = "Add Time",
  CREATE_EVENT = "Create Event",
  DELETE_EVENT = "Delete Event",
  EDIT_EVENT = "Edit Event",
  CREATE_TOUR = "Create Tour",
  CREATE_LEAGUE = "Create League",
  UPDATE_LEAGUE = "Update League",
  DELETE_LEAGUE = "Delete League",
  UPDATE_ROUND = "Update Round",
  CREATE_ROUND = "Create Round",
  DELETE_ROUND = "Delete Round",
  CREATE_ROUND_CONFIG = "Create Round Config",
  SHOW_LIST_VIEW = "Show List View",
  SHOW_GRID_VIEW = "Show Grid View",
  LEAGUE_VIEW_LEADERBOARD = "View League Leaderboard",
  LEAGUE_VIEW_ROSTER = "View League Roster",
  LEAGUE_VIEW_ROUNDS = "View League Rounds",
  LEAGUE_EDIT = "Edit League",
  LEAGUE_DELETE = "League Delete",
  LEAGUE_CREATE = "League Create",
  LEAGUE_ROUND_VIEW_GROUPS = "View League Round Groups",
  LEAGUE_ROUND_VIEW_LEADERBOARD = "View League Round Leaderboard",
  LEAGUE_ROUND_EDIT = "Edit League Round",
  LEAGUE_ROUND_DELETE = "Delete League Round",
  LEAGUE_ROUND_CREATE = "Create League Round",
  LEAGUE_ROUND_CREATE_GROUP = "Create League Round Group",
  LEAGUE_REMOVE_TEAM_FROM_GROUP = "League Remove Team From Group",
  LEAGUE_REMOVE_PLAYER_FROM_GROUP = "League Remove Player From Group",
  LEAGUE_ADD_TEAM_TO_GROUP = "League Add Team To Group",
  LEAGUE_ADD_PLAYER_TO_GROUP = "League Add Player To Group",
  LEAGUE_ROUND_SEND_GROUPS_TO_SIM = "Send Groups to Simulator",
  LEAGUE_ROUND_ASSIGN_GROUP_TO_SIM = "Assign Group to Simulator",
  LEAGUE_CREATE_TEAM = "Create League Team",
  LEAGUE_EDIT_TEAM = "Edit League Team",
  LEAGUE_DELETE_TEAM = "Delete League Team",
  LEAGUE_CREATE_MATCH = "Create League Match",
  LOCKER_ROOM_VIEW = "View Locker Room",
  LOCKER_ROOM_EXPORT = "Export Locker Room",
  MOVE_ROUND_TO_SIM = "Move Round to Simulator",
  VIEW_LIVE_SCREENSHOTS = "Live Screenshots",
  UPDATE_FACILITY = "Update Facility Management",
  METRICS_VIEW = "Get Simulator Shot Metrics",
  EVENTS_VIEW = "Get Simulator Events",
  TOURS_VIEW = "Get Tours",

  VIEW_SCORECARD_IMAGE = "View Scorecard Image",
  VIEW_SCORECARD_TEXT = "View Scorecard Text",
  SEND_SIMULATOR_MESSAGE = "Send Simulator Message",
  UPDATE_AG_HANDICAP = "Update AG Handicap",
  UPDATE_SIMULATORS = "Update Simulator Management",
}

export enum ClubhouseClickEvents {
  CREATE_RESERVATION = "Create Reservation",
  VIEW_FACILITY_MANAGEMENT = "View Facility Management",
  VIEW_SIMULATOR_MANAGEMENT = "View Simulator Management",
  VIEW_ROUND_PRESETS = "View Round Presets",
  VIEW_QUEUE = "View Queue",
  VIEW_HANDICAP = "View Handicap",
  VIEW_SIMULATOR_SHOT_METRICS = "View Simulator Shot Metrics",
  VIEW_REX_ADMIN_SITE = "View Rex Admin Site",
  VIEW_MARKETING_MATERIALS = "View Marketing Materials",
}
